(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-purity-warranty"]) return;
  try {
    
(() => {
  const messages = JSON.parse(document.getElementById('bgs-certificate-messages').textContent);
  function setup() {
    const input = document.getElementById('certInput');
    const output = document.getElementById('statusMsg');
    const button = input?.parentElement.querySelector('button');
    if (!input || !output || !button || input.dataset.bgsBridge) return;
    input.dataset.bgsBridge = '1';
    input.setAttribute('aria-label', messages.number);
    input.setAttribute('maxlength', '80');
    output.setAttribute('role', 'status');
    output.setAttribute('aria-live', 'polite');
    let busy = false;
    const isToken = key => /^(?:[a-f0-9]{32}|[a-f0-9]{48})$/i.test(key);
    const isNew = key => /^BGS-(916|999)-[a-f0-9]{12}$/i.test(key) || isToken(key) || /^sample-not-valid-/.test(key);
    function message(text, color = '#192b28') {
      output.replaceChildren();
      output.style.display = 'block';
      output.style.backgroundColor = '#fff';
      output.style.border = '1px solid #ddd';
      output.style.color = color;
      output.textContent = text;
    }
    async function verify() {
      if (busy) return;
      let key = input.value.trim();
      if (!key) { message(messages.empty, '#9b3030'); return; }
      if (!/^[A-Za-z0-9-]{1,80}$/.test(key)) { message(messages.malformed, '#9b3030'); return; }
      if (!isNew(key)) {
        if (typeof window.checkCertificate === 'function') window.checkCertificate();
        else if (typeof window.sendToWhatsApp === 'function') window.sendToWhatsApp();
        else message(messages.legacy, '#9b3030');
        return;
      }
      if (/^BGS-/i.test(key)) key = key.toUpperCase();
      else if (isToken(key)) key = key.toLowerCase();
      busy = true;
      button.disabled = true;
      input.disabled = true;
      message(messages.checking);
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 45000);
      try {
        const response = await fetch('/apps/best-gold-certificates?format=json&certificate=' + encodeURIComponent(key), {headers: {Accept: 'application/json'}, cache: 'no-store', credentials: 'same-origin', signal: controller.signal});
        if (!response.ok) throw new Error('Verification unavailable');
        const payload = await response.json();
        if (!Object.prototype.hasOwnProperty.call(payload, 'certificate')) throw new Error('Invalid response');
        const cert = payload.certificate;
        if (!cert) { message(messages.not_found, '#9b3030'); return; }
        const valid = cert.status === 'valid';
        message(valid ? messages.valid : messages.invalid + String(cert.status || messages.unknown).toUpperCase(), valid ? '#236b45' : '#9b3030');
        for (const text of [cert.number, cert.item, cert.purity ? cert.purity + messages.gold : '', cert.inspection, messages.inspection]) {
          if (!text) continue;
          const line = document.createElement('p');
          line.textContent = String(text);
          output.appendChild(line);
        }
      } catch {
        message(messages.unavailable, '#9b3030');
      } finally {
        clearTimeout(timer);
        busy = false;
        button.disabled = false;
        input.disabled = false;
      }
    }
    button.addEventListener('click', event => { event.preventDefault(); event.stopImmediatePropagation(); void verify(); }, true);
    input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); void verify(); } });
    const key = new URLSearchParams(window.location.search).get('certificate');
    if (key && /^[A-Za-z0-9-]{1,80}$/.test(key)) { input.value = key; void verify(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once: true});
  else setup();
})();

  } catch(e) { console.error(e); }
})();
})();
